import { type ComponentPropsWithoutRef, type ReactNode } from 'react';
import cx from 'clsx';
import styles from './label-list-icon.module.css';

interface LabelListIconProps extends ComponentPropsWithoutRef<'div'> {
  labelList: {
    name: string;
    color: string;
  };
}

export function LabelListIcon({ labelList, className, ...props }: LabelListIconProps): ReactNode {
  const { name, color } = labelList;

  return (
    <div
      aria-label={name}
      className={cx(styles.icon, className)}
      data-test-label-list-name={name}
      style={{ backgroundColor: color }}
      {...props}
    />
  );
}
